module.exports = __webpack_public_path__ + "static/media/logo.aba790e0.svg";